import {
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-claim-status-popover',
  templateUrl: './claim-status-popover.component.html',
  styleUrls: ['./claim-status-popover.component.scss'],
})
export class ClaimStatusPopoverComponent implements OnInit, OnChanges {
  @HostBinding('class.claim-status-popover')
  hasClass = true;

  @Input() approvals: any[] = [];
  @Input() overallStatus: number = 0;

  displayStatus: number = 0;

  ngOnInit(): void {
    this.resolveDisplayStatus();
  }

  ngOnChanges(): void {
    this.resolveDisplayStatus();
  }

  private resolveDisplayStatus(): void {
    this.displayStatus = this.overallStatus ?? 0;
  }

  getStatusLabel(status: number): string {
    switch (status) {
      case 0:
        return 'Pending';
      case 1:
        return 'Approved';
      case 2:
        return 'Rejected';
      case 3:
        return 'Cancelled';
      default:
        return '---';
    }
  }

  getStatusClass(status: number): string {
    switch (status) {
      case 0:
        return 'badge-warning';
      case 1:
        return 'badge-success';
      case 2:
        return 'badge-danger';
      case 3:
        return 'badge-secondary';
      default:
        return 'badge-secondary';
    }
  }

  getStatusShort(status: number): string {
    switch (status) {
      case 0:
        return 'P';
      case 1:
        return 'A';
      case 2:
        return 'R';
      case 3:
        return 'C';
      default:
        return '-';
    }
  }
}
